import { SectionWrapper } from "pages/Product/styled";
import React from "react";
import styled from "styled-components/macro";
import { mediaMin } from "styles/media";
import config from "../../config";

const StyledSectionWrapper = styled(SectionWrapper)`
  position: relative;
  height: 100vh;
  padding-top: 120px;
  padding-bottom: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MobileImage = styled.img`
  width: 140px;
  display: block;

  ${mediaMin.xs`
    display: none;
  `};
`;

const TabletImage = styled.img`
  width: 210px;
  display: none;

  ${mediaMin.xs`
    display: block;
  `};

  ${mediaMin.md`
    display: none;
  `};
`;

const DesktopImage = styled.img`
  width: 264px;
  display: none;
  ${mediaMin.md`
    display: block;
  `};

  ${mediaMin.lg`
    width: 284px;
  `};
`;

const QuestionMarkImageWrapper = styled.div`
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Title = styled.h1`
  margin: 0 auto;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
  white-space: pre-line;
  text-align: center;

  ${mediaMin.xs`
    font-size: 32px;
  `};

  ${mediaMin.md`
    font-size: 40px;
  `};
`;

export function QuestionMarkSection() {
  return (
    <StyledSectionWrapper>
      <QuestionMarkImageWrapper>
        <DesktopImage
          src={`${config.RESOURCE_ORIGIN}/images/landing/product/hero-question-desktop.png`}
        />
        <TabletImage
          src={`${config.RESOURCE_ORIGIN}/images/landing/product/hero-question-tablet.png`}
        />
        <MobileImage
          src={`${config.RESOURCE_ORIGIN}/images/landing/product/hero-question-mobile.png`}
        />
      </QuestionMarkImageWrapper>
      <Title>
        What is needed to{"\n"}
        succeed in client projects?
      </Title>
    </StyledSectionWrapper>
  );
}
